// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"60":"85d1a747","371":"f6a8b0c4","408":"d81aff16","898":"cb9b8c17","996":"f8ef559f"}[chunkId] + ".css";
};